export function AdminDashboard() {
  return (
    <div className="stack">
      <div><h1>Dashboard Admin</h1><p className="muted">Foundation untuk pengguna, kurikulum, worksheet, audio, dan audit.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Murid</span><strong>237</strong></div>
        <div className="metric"><span>Guru</span><strong>18</strong></div>
        <div className="metric"><span>Worksheet</span><strong>1.256</strong></div>
      </section>
    </div>
  );
}
